import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layouts/admin/admin.component';
// import { 
//   AuthGuardService as AuthGuard 
// } from '../auth/auth-guard.service';

const routes: Routes = [
  {
      path: '',
      component: AdminComponent, 
      // canActivate: [AuthGuard],
      children: [
          { path: '', redirectTo: 'pages', pathMatch: 'full' },
          { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.StaterPageModule) },
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
